import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthCookiesResolver } from "./utils/resolver/auth-cookies.resolver";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./modules/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "Query",
    resolve: { authCookies: AuthCookiesResolver },
    loadChildren: () =>
      import("./modules/query-apbuilder/query-apbuilder.module").then(
        (m) => m.QueryApbuilderModule
      ),
  },
  { path: "**", redirectTo: "", pathMatch: "full" },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
